module.exports = __webpack_public_path__ + "img/234.toilet_services.dc16d4c4.svg";